import { z } from 'zod';
import { backendIdentitySchema } from './artifacts';
import { blobAssetSchema } from './jobs';
import { macroVisualDigestSchema } from './common';

const count = z.number().int().nonnegative().max(1_048_576);
export const validationCountsSchema = z.object({
  acceptedPositives: count, rejectedNegatives: count, negativeAbstentions: count,
  misses: count, falseMatches: count, invalidEvidence: count,
}).strict();
export const contextValidationSummarySchema = z.object({
  contextId: z.string().min(1).max(128), ready: z.boolean(),
  positiveStates: z.array(z.string().min(1).max(128)).max(64), negativeCases: count,
  /** States that accepted a held-out negative; advisory, not native calibration readiness. */
  falseMatchStateIds: z.array(z.string().min(1).max(128)).max(64).optional(),
  diagnosticCases: count,
  max: validationCountsSchema, product: validationCountsSchema, noisyOr: validationCountsSchema,
}).strict();
export const analysisReportPageSchema = z.discriminatedUnion('kind', [
  z.object({ kind: z.literal('contexts'), rows: z.array(contextValidationSummarySchema).max(128) }).strict(),
  z.object({ kind: z.literal('chunks'), rows: z.array(z.object({
    sequence: z.number().int().nonnegative().max(8191), asset: blobAssetSchema,
    rowCount: z.number().int().min(1).max(128), bindingDigest: macroVisualDigestSchema,
    epoch: z.number().int().positive(), backend: backendIdentitySchema,
  }).strict()).max(128) }).strict(),
]);
export type ValidationCounts = z.infer<typeof validationCountsSchema>;
export type ContextValidationSummary = z.infer<typeof contextValidationSummarySchema>;
export type AnalysisReportPage = z.infer<typeof analysisReportPageSchema>;
export const analysisReportResultPageSchema = z.object({ page: analysisReportPageSchema.nullable(),
  nextCursor: z.string().min(1).max(2048).optional() }).strict();
export type AnalysisReportResultPage = z.infer<typeof analysisReportResultPageSchema>;
